
import { eoRendererMixin, metaDataMixin } from '~/mixins'

export default {
  mixins: [
    eoRendererMixin,
    metaDataMixin,
  ],
  async asyncData ({ $api, params: { slug }, store, route, error }) {
    const {
      data: {
        items: [
          person = {},
        ] = [],
      } = {},
    } = await $api.persons.getOneBySlug(slug, {
      domain: 'nederlandzingt-eo',
    })

    if (!person.id) {
      error({
        context: `Couldn't find person: ${slug}.`,
        message: '(404) Artiest niet gevonden',
        severity: 'warning',
        statusCode: 404,
      })
      return false
    }

    // Set breadcrumbs
    await store.dispatch('breadcrumbs/set', {
      path: route.path,
      width: 12,
      eoRoot: true,
      items: [
        {
          to: '/',
          label: 'Nederland Zingt',
        },
        {
          label: person.name,
        },
      ],
    })

    return person
  },
  data () {
    return {
      articles: [],
      articlesToFetch: null,
      biography: null,
      id: null,
      name: null,
      email: null,
      facebook: null,
      instagram: null,
      linkedin: null,
      phone: null,
      snapchat: null,
      spotify: null,
      tiktok: null,
      twitter: null,
      head: {
        meta: [
          { hid: 'type', content: 'Artiest' },
        ],
      },
    }
  },
  fetchOnServer: false,
  async fetch () {
    const {
      data: {
        items: articles = [],
        meta: {
          total = 0,
        } = {},
      } = {},
    } = await this.$api.persons.getAllNested('articles', this.id, { personType: 'person', offset: this.articles.length, limit: 6 })

    this.articles.push(...articles)
    this.articlesToFetch = total - this.articles.length
  },
}
